<template>
  <div class="feedBack_analysis">
    <div class="item-title">{{ $t('asm_feedBack_analysis.shen_pi_jie_guo') }}</div>
     <div class="item">
      <h3>{{ $t('asm_feedBack_analysis.ke_fu_chu_li_jie_guo') }}</h3>
      <p>{{ (result.handleResultCs && result.handleResultCs.content) || '-' }}</p>
      <div class="footer">
        <p>
          <span class="lable">{{ $t('asm_feedBack_analysis.tian_xie_ren') }}：</span>
          {{ (result.handleResultCs && result.handleResultCs.optUser) || '-' }}
        </p>
        <p>
          <span class="lable">{{ $t('Common.com_date') }}：</span>
          {{ (result.handleResultCs && $momentLocal(result.handleResultCs.optTime, 'YYYY-MM-DD')) || '-' }}
        </p>
      </div>
    </div>
    <div class="item">
      <h3>{{ $t('asm_feedBack_analysis.yuan_yin_fen_xi') }}</h3>
      <p>{{ (result.causeAnalysis && result.causeAnalysis.content) || '-' }}</p>
      <div class="footer">
        <p>
          <span class="lable">{{ $t('asm_feedBack_analysis.tian_xie_ren') }}：</span>
          {{ (result.causeAnalysis && result.causeAnalysis.optUser) || '-' }}
        </p>
        <p>
          <span class="lable">{{ $t('Common.com_date') }}：</span>
          {{ (result.causeAnalysis && $momentLocal(result.causeAnalysis.optTime, 'YYYY-MM-DD')) || '-' }}
        </p>
      </div>
    </div>
    <div class="item">
      <h3>{{ $t('asm_feedBack_analysis.gai_shan_cuo_shi') }}</h3>
      <p>{{ (result.improveMethod && result.improveMethod.content) || '-' }}</p>
      <div class="footer">
        <p>
          <span class="lable">{{ $t('asm_feedBack_analysis.tian_xie_ren') }}：</span>
          {{ (result.improveMethod && result.improveMethod.optUser) || '-' }}
        </p>
        <p>
          <span class="lable">{{ $t('Common.com_date') }}：</span>
          {{ (result.improveMethod && $momentLocal(result.improveMethod.optTime, 'YYYY-MM-DD')) || '-' }}
        </p>
      </div>
    </div>
    <div class="item">
      <h3>{{ $t('asm_feedBack_analysis.pzcljg') }}</h3>
      <p>{{ (result.handleResultQc && result.handleResultQc.content) || '-' }}</p>
      <div class="footer">
        <p>
          <span class="lable">{{ $t('asm_feedBack_analysis.tian_xie_ren') }}：</span>
          {{ (result.handleResultQc && result.handleResultQc.optUser) || '-' }}
        </p>
        <p>
          <span class="lable">{{ $t('Common.com_date') }}：</span>
          {{ (result.handleResultQc && $momentLocal(result.handleResultQc.optTime, 'YYYY-MM-DD')) || '-' }}
        </p>
      </div>
    </div>

  </div>
</template>

<script>
import apis from '@/utils/apis';
/**

 */

export default {
  name: '',
  props: {
    feedBackId: [Number, String],
  },
  data() {
    return {
      result: {},
    };
  },

  methods: {
    getResultInfo() {
      this.$getJSON(apis.feedbackApprovalResultInfo, {
        feedBackId: this.feedBackId,
      }).then((res) => {
        this.result = res.data;
      });
    },
  },
  mounted() {
    this.getResultInfo();
  },
};
</script>

<style lang="scss" scoped>
.feedBack_analysis {
  padding: 0 16px;
  .item-title {
    margin: 16px 0;
  }
  .item {
    margin-top: 16px;
    padding: 14px 16px;
    border: 1px solid #eef2f8;
    h3 {
      font-size: 14px;
      font-weight: 500;
      color: #262626;
      line-height: 20px;
    }
    p {
      color: #6c757d;
      font-size: 12px;
    }
    .footer {
      p {
        text-align: right;
        color: #262626;
        font-size: 12px;
        .lable {
          font-weight: 500;
          color: #6e6e6e;
        }
      }
    }
  }
}
</style>
